import { EXPERIMENT_STATUS, MAP_MODES, PLOTMAP_STATUS } from "../../constants";
import { selectFilteredTrials, selectSortedTrials } from "../../selectors/user";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";

import L from "leaflet";
import { Marker } from "@adamscybot/react-leaflet-component-marker";
import { TrialBadge } from "./TrialBadge";
import { fetchResultMapFeatures } from "../../actions/resultMap";
import { useMap } from "react-leaflet";

export const TrialMarkerCluster = () => {
  const [mapMode, selectedTrial, filterByStatusMode] = useSelector(
    ({ resultMap }) => [
      resultMap.mapMode,
      resultMap.trial,
      resultMap.filterByStatusMode,
    ]
  );

  // Display filtered trials based on selected contract if mode is markers/cluster
  // However if a trial is selected, display all trials in mode markers
  const trials = useSelector(
    selectedTrial && mapMode === MAP_MODES.MARKERS
      ? selectSortedTrials
      : selectFilteredTrials
  );

  const filteredByStatusTrials = useMemo(() => {
    if (trials && filterByStatusMode) {
      const trialsWithActionRequired = trials.filter((trial) => {
        const matchesStatus =
          [EXPERIMENT_STATUS.NOT_STARTED, EXPERIMENT_STATUS.DRAFT].includes(
            trial.experiment_status
          ) || trial.plotmap_status === PLOTMAP_STATUS.WAITING_FOR_VALIDATION;

        return matchesStatus;
      });

      return trialsWithActionRequired;
    }
    return trials;
  }, [trials, filterByStatusMode]);

  const dispatch = useDispatch();

  const map = useMap();

  useEffect(() => {
    // Global zoom when mode is markers
    if (mapMode === MAP_MODES.MARKERS) map.setView([26.0, 30.0], 3);
    if (mapMode === MAP_MODES.CLUSTER && trials.length) {
      const bounds = L.latLngBounds(
        trials.map(({ trial_position }) => trial_position)
      );
      map.fitBounds(bounds, { maxZoom: 15 });
    }
  }, [map, mapMode, trials]);

  return filteredByStatusTrials.map((trial) => (
    <Marker
      key={trial.id}
      position={trial.trial_position}
      icon={
        <TrialBadge
          modeMarkers={mapMode === MAP_MODES.MARKERS}
          disableClick
          trial={trial}
        />
      }
      eventHandlers={{
        click: () =>
          dispatch(fetchResultMapFeatures(trial, trial.trial_dates.at(-1))),
      }}
    />
  ));
};
